module.exports = __webpack_public_path__ + "img/H-B-2-load-standup-shadow.58ea2258.png";